<div class="flex flex-col h-screen">
<!--  <u-header [currentUser$]="currentUser$"></u-header>-->
  <div class="mb-auto flex-1 flex-grow">
    <router-outlet></router-outlet>
  </div>
<!--  <u-footer></u-footer>-->
</div>
